module.exports = __webpack_public_path__ + "static/img/4.74bd8f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/4.png
// module id = Aick
// module chunks = 1